import React, { FC, Suspense } from 'react';
import { WelderProgressTreeItemContainerStyled } from '../styled';
import { IconLayoutContainerStyled } from './styled';
import { Box, Text, Icon, IconSize, useSideSheetState } from '@bechtel/gds';
import { UserInfo } from '~/components/organisms/user-info';
import { ErrorBoundary, SuspenseLoader } from '@bechtel/client-common';
import { EditMultipleRodRequest } from '@bechtel/client-rod-room';
import { CrewMember, Scalars } from '@bechtel/types';

export interface RodRequestItemProps {
  crewMember: CrewMember;
  numRodRequests: Scalars['Int'];
}

export const RodRequestItem: FC<RodRequestItemProps> = ({ crewMember, numRodRequests }) => {
  const {
    visible: visibleEditRodRequest,
    open: openEditRodRequestSideSheet,
    close: closeEditRodRequestSideSheet,
  } = useSideSheetState(false);
  return (
    <WelderProgressTreeItemContainerStyled>
      <Box style={{ justifySelf: 'left' }}>
        <UserInfo crewMember={crewMember} showBadgeNumber={true} />
      </Box>
      <Text size="300" color="grey.700" family="graphik">
        {numRodRequests}
      </Text>
      <Box justifyContent={{ sm: 'center' }} onClick={openEditRodRequestSideSheet}>
        <IconLayoutContainerStyled>
          <Icon fillColor="blue.800" icon="edit" size={IconSize.MEDIUM} />
        </IconLayoutContainerStyled>
      </Box>
      <Box justifyContent={{ sm: 'center' }}>
        <IconLayoutContainerStyled>
          <Icon fillColor="blue.800" icon="list" size={IconSize.MEDIUM} />
        </IconLayoutContainerStyled>
      </Box>
      <ErrorBoundary>
        <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
          {visibleEditRodRequest && (
            <EditMultipleRodRequest
              crewMember={crewMember}
              numRodRequests={numRodRequests}
              onClose={closeEditRodRequestSideSheet}
            />
          )}
        </Suspense>
      </ErrorBoundary>
    </WelderProgressTreeItemContainerStyled>
  );
};
